import { consumeLoading } from "@/lib/consume/loading"
import { consumeRouter } from "@/lib/consume/router"
import { NoticesContainerComponent } from "@/lib/notices/container/component"

export const NoticesContainerConsumer = consumeLoading(
  consumeRouter(NoticesContainerComponent)
)
